import script from "./PopularRuns.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularRuns.vue?vue&type=script&setup=true&lang=ts"

import "./PopularRuns.vue?vue&type=style&index=0&id=c22f0eb4&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c22f0eb4"]])

export default __exports__